import ContactSyncGrid from './contact-sync-grid';

export default function ContactSyncPage() {
  return <ContactSyncGrid />;
}
